export const cookiePolicy = `# Политика использования файлов Cookie

**Сайт:** kolodec-septiki.ru  
**Дата вступления в силу:** 7 мая 2026 г.

---

## 1. Что такое cookie

Файлы cookie — это небольшие текстовые файлы, которые сохраняются браузером на вашем устройстве при посещении сайта. Они позволяют сайту запоминать ваши действия и предпочтения.

---

## 2. Какие cookie мы используем

| Тип cookie | Назначение | Срок хранения | Возможность отключения |
|---|---|---|---|
| **Строго необходимые** | Обеспечивают базовую работу сайта: запоминание согласия на cookie, сессионные данные | Сессия или до 12 мес. | Нет |
| **Аналитические** | Яндекс.Метрика: сбор статистики посещаемости, анализ поведения пользователей | До 12 месяцев | Да |
| **Маркетинговые** | Ретаргетинг, показ рекламы по интересам (при подключении рекламных систем) | До 12 месяцев | Да |

---

## 3. Аналитические сервисы

Сайт использует **Яндекс.Метрику** (ООО «Яндекс», ИНН 7736207543). Данный сервис может собирать следующие данные:
- IP-адрес (в обезличенном виде);
- тип браузера и устройства;
- страницы, которые вы посетили;
- время и продолжительность визита.

Политика конфиденциальности Яндекса: https://yandex.ru/legal/confidential/

---

## 4. Управление cookie

### Через баннер на сайте
При первом посещении kolodec-septiki.ru отображается cookie-баннер с выбором: «Принять все», «Только необходимые», «Настроить». Аналитические и маркетинговые скрипты загружаются **только после вашего согласия**.

### Через настройки браузера
Вы можете удалить или заблокировать cookie в настройках браузера:
- **Chrome:** Настройки → Конфиденциальность → Файлы cookie
- **Firefox:** Настройки → Приватность и защита
- **Safari:** Настройки → Конфиденциальность
- **Яндекс.Браузер:** Настройки → Сайты → Расширенные настройки сайтов

Обратите внимание: отключение необходимых cookie может повлиять на работу сайта.

---

## 5. Правовые основания

Обработка данных через cookie осуществляется:
- для строго необходимых cookie — на основании **законного интереса** Оператора (ст. 6 ч. 1 п. 7 Закона № 152-ФЗ);
- для аналитических и маркетинговых cookie — на основании **согласия** пользователя (ст. 9 Закона № 152-ФЗ).

---

## 6. Контакты

По вопросам, связанным с использованием cookie:

**ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ**  
Email: info@kolodec-septiki.ru  
Адрес: 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1
`;
